/*
Version 0.115

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2018
	01-03-2018
	- [ADDED] Added document.ready to onready.
	26-02-2018
	- [ADDED] Open en Close methods are extended with new function to prevent body scrolling when menu is open
2017
	30-11-2017
	- [CHANGE] .js-menu-button is now changed to .js-mobile-menu-button
	15-10-2017
	- [METHOD] Add and remove .active class to the js-menu-button.
	30-08-2017
	- [BORN] This class is born. Hooray!

!Usage
	specific_mobilemenu.onready();

	
!Wishlist

	none
	
*/
  
var specific_work = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	// none
	 
	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************
	
	this.onready = function() {

		/*
		Filter: Dropdown select
		*/
		$(document).on('click','.js-custom-select', function () {

			$('.js-custom-select').find('.options').stop().slideToggle();

			if(
				!$(this).hasClass('open')
			) {
				$('.js-custom-select').removeClass('open');
				$(this).addClass('open');
			} else {
				$(this).removeClass('open');
			}			

		});

		// Optie aanklikken
		// $options.on('click', function () {
		// const value = $(this).data('value');
		// const label = $(this).text();

		// $selected.find('.label').text(label);
		// $select.removeClass('open');

		// console.log('Gekozen waarde:', value);
		// // Hier kun je eventueel ook een hidden input bijwerken of iets doorsturen
		// });

		// // Sluiten bij klik buiten dropdown
		// $(document).on('click', function (e) {
		// if (!$(e.target).closest('.custom-select').length) {
		// 	$select.removeClass('open');
		// }
		// });

	};
		
}).apply(specific_work); 